import { Alert } from "@mui/material";
import { intl } from "LocaleWrapper";

const ParentContractCharterAlert = () => {
	return (
		<Alert severity="info">
			{intl.formatMessage({ id: "CHARTER_LINKED_TO_PARENT_CONTRACT" })}
		</Alert>
	);
};

export default ParentContractCharterAlert;
